package br.com.texeratx.boardgametimeapp.core.active_match

import kotlinx.serialization.Serializable

/**
 * Representa a partida ativa (config + instante em que começou).
 *
 * IMPORTANTE:
 * - A gente salva startedAtEpochMillis (timestamp absoluto)
 * - NUNCA "conta" tempo. Sempre calcula: agora - startedAt.
 */

@Serializable
data class ActiveMatch(
    val gameId: Long,
    val gameName: String,

    val gameImageUrl: String? = null,

    val playerIds: List<Long>,
    val playerNames: List<String>,

    val playerImageUrls: List<String?> = emptyList(),

    val expansionIds: List<Long>,
    val expansionNames: List<String>,
    val startedAtEpochMillis: Long,
    val firstPlayerIndex: Int,
)
